export default function useActiveItem({ activeShopItem, shopItems }) {
  return shopItems?.find(({ id }) => id === activeShopItem);
}
